export class NumPendingElementsChangedEvent {
  constructor(readonly numPendingElements: number) {}
}
